import React from 'react';
import { injectIntl } from 'react-intl';
import { ICollectionPoint } from '../../util/DataModelInterface';
import { ListGroup } from 'react-bootstrap';
import { exportCompareSummaryReport, ReportRow } from '../../api/SummaryReport';

export interface ICollectionPointListProps {
  intl: any;
  points: ICollectionPoint[]; 
}

const COLUMNS = [
  'collectionpoint_id',
  'name',
  'operational_state',
  'street_address',
  'zip_code',
  'city',
  'community',
  'dataser',
  'store_point',
  'container_point'
];

class CollectionPointList extends React.Component<ICollectionPointListProps, any> {

  shouldComponentUpdate(newProps: ICollectionPointListProps) {
    // Rendering the component only if 
    // passed props value is changed
    if (newProps.points.length !== this.props.points.length ||
        newProps.points !== this.props.points) {
      return true;
    } else {
      return false;
    }
  }
  formatDataForExport = (data: ICollectionPoint[]) => {
    let formatted = [] as ReportRow[];
    data.forEach((d: ICollectionPoint) => {
      let row = {} as ReportRow;
      COLUMNS.forEach((name) => {
        let key = this.props.intl.formatMessage({id:`settings.collectionpoints.${name}`});
        let value = d.info[name as keyof typeof d.info];
        if(typeof value === 'boolean') value = this.props.intl.formatMessage({id:`settings.collectionpoints.${value.toString()}`});
        if(name === 'operational_state')
          value = this.props.intl.formatMessage({id:`settings.collectionpoints.${d.info[name as keyof typeof d.info]}`});
        row[key] = value;
      })
      formatted.push(row);
    });
    return formatted;
  }

  getListItemStyle = (p: ICollectionPoint) : string => {
    let style = "card-header d-flex flex-row align-items-center ListItem";
    if(p.info.operational_state !== 'InUse') style += "NotInUse"
    return style;
  }

  getCollectionPoints = (points: ICollectionPoint[]) => {
    const options: { }[] = [];
    if (points) {
      points.forEach((p : ICollectionPoint) => {
        options.push(
          <ListGroup.Item key={p.info.collectionpoint_id}
                          className={ this.getListItemStyle(p) }>
            <div className="card-subtitle">{p.info.collectionpoint_id}</div>
            <div className="card-subtitle name">{p.info.name}</div>
            <div className="card-subtitle">{p.info.street_address} {p.info.zip_code} {p.info.city} {p.info.community ? '(' + p.info.community + ')' : ''} </div>
            <div className="card-subtitle">{ p.info.store_point ? this.props.intl.formatMessage({id: 'settings.operators.stores'}) : '' }</div>
            <div className="card-subtitle">{p.info.dataser ? this.props.intl.formatMessage({id: 'settings.collectionpoints.dataser'}) : '' }</div>
            <div className="card-subtitle">{p.info.container_point ? this.props.intl.formatMessage({id: 'settings.collectionpoints.container'}) : this.props.intl.formatMessage({id: 'settings.collectionpoints.pallet'}) }</div>
          </ListGroup.Item>
        );
      });
      return options;
    }
  }

  render() {
    return (
      <div>
        <div className="d-flex flex-row align-items-center">
            <h3 className="sub-label">{ this.props.intl.formatMessage({id: 'settings.operators.collectionpoints'}) }</h3>
              <button
                className={"btn btn-primary ml-md-auto mb-4"} key={this.props.points.length}
                onClick={() => exportCompareSummaryReport('collectionpoints',
                              { header: this.props.intl.formatMessage({id: 'settings.operators.collectionpoints'}),
                                data: this.formatDataForExport(this.props.points),
                                compareHeader: "", compareData: {}})}>
                { this.props.intl.formatMessage({id: 'comparereport.datatable.export'}) }
              </button>
          </div>
          <ListGroup className="form-group">
            { this.getCollectionPoints(this.props.points) }
          </ListGroup>
      </div>
    );
  }
};

export default injectIntl(CollectionPointList);